import styled from "@emotion/styled";
import { Box } from "@otrium/core";
import { Content } from "src/atoms/Content";
import { Skeleton } from "src/atoms/Skeleton";

export const StyledCollectionsCoverContainer = styled(Box)<{
  minimizeHeightOnMobile: boolean;
}>`
  position: relative;
  height: 480px;
  width: 100%;
  background: ${(props) => props.theme.colors.tone.silver};

  :before {
    width: 100%;
    height: 100%;
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    top: 0;
    left: 0;
    z-index: 1;
    opacity: 0.6;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000);
  }

  ${({ minimizeHeightOnMobile, theme }) =>
    minimizeHeightOnMobile &&
    `
      @media (max-width: ${theme.breakpoints[2]}) {
        height: 300px;
      }
    `}
`;

export const StyledSkeleton = styled(Skeleton)`
  width: 100%;
  height: 250px;
  object-fit: cover;
`;

export const Image = styled("img")`
  object-fit: cover;
  object-position: top;
  width: 100%;
  height: 100%;
`;

export const CustomContent = styled(Content)`
  display: grid;
  row-gap: ${({ theme }) => theme.space.space32};
  padding: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    row-gap: ${({ theme }) => theme.space.space24};
  }
`;
